<div [ngClass]="getClass()" [formGroup]="cueForm">
  <div class="header flex justify-between" (click)="setValueAtCursor.emit()">
    <div class="flex-1">{{ label }}</div>
    <div (click)="clickOnTrash($event)">
      <mat-icon [fontSet]="'fa'" [fontIcon]="'fa-trash'"></mat-icon>
    </div>
  </div>
  <rk-form-field>
    <input
      rkInput
      class="cue-input"
      type="text"
      formControlName="value"
      (keydown)="onKeydown($event)"
      (click)="onClick()"
      (blur)="onBlur()"
      #inputTime
    />
  </rk-form-field>
</div>
